/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveProjectTasksCommand } from '../../models/approve-project-tasks-command';
import { ApproveProjectTasksCommandResult } from '../../models/approve-project-tasks-command-result';

export interface ApiProjectApproveProjectTasksPatch$Params {
      body?: ApproveProjectTasksCommand
}

export function apiProjectApproveProjectTasksPatch(http: HttpClient, rootUrl: string, params?: ApiProjectApproveProjectTasksPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<ApproveProjectTasksCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectApproveProjectTasksPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApproveProjectTasksCommandResult>;
    })
  );
}

apiProjectApproveProjectTasksPatch.PATH = '/api/Project/ApproveProjectTasks';
